import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';
import { sessionStore } from 'src/store/sessionStore';
import { ProgressItem } from 'src/store/programGeneratorProgressStore';

export interface GetProgramsPayload {
  program_ids?: string[];
  client_id?: string;
}

export interface ProgramProgressData {
  id: string;
  trainer_id: string;
  client_id: string | null;
  status: string;
  progress: Record<string, ProgressItem[]>;
  created_at: string;
  updated_at: string;
}

export interface GetProgramsResponse {
  status: string;
  data: ProgramProgressData[];
}

const getPrograms = async (
  payload: GetProgramsPayload,
  uid: string,
): Promise<ProgramProgressData[]> => {
  const apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_PROGRAMS}`;

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...payload, uid }),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch programs');
  }

  const res: GetProgramsResponse = await response.json();
  return res.data;
};

export const useGetPrograms = (
  payload: GetProgramsPayload = {},
  options?: { enabled?: boolean },
) => {
  const currentUser = sessionStore((state) => state.currentUser);
  const uid = currentUser?.uid;

  return useQuery({
    queryKey: ['trainer-programs', payload],
    queryFn: () => {
      if (!uid) {
        throw new Error('User not authenticated');
      }
      return getPrograms(payload, uid);
    },
    enabled: !!uid && options?.enabled !== false,
  });
};
